import React from 'react';
import './index.css';

import { Outlet } from 'react-router-dom';
import { AuthProvider } from './Auth/AuthProvider';
import { ModalProvider } from './contexts/ModalContext';
import { ToastProvider } from './contexts/ToastContext';
import { AmbienteProvider } from './contexts/AmbienteMedicaoContext';

function App() {
  return (
    <AuthProvider>
      <ModalProvider>
        <ToastProvider>
          <AmbienteProvider>
            <div className="App">
              <Outlet />
            </div>
          </AmbienteProvider>
        </ToastProvider>
      </ModalProvider>
    </AuthProvider>
  );
}

export default App;